import { Modal } from 'antd';

import { MODAL_RESPONSE_TYPE } from '../../constants/modal.constants';
import { BaseButtonFill, BaseButtonLink, BaseIcon } from '..';

import './BaseModal.scss';

export const BaseModal = (props) => {
  const { icon, title, description, customContent, okButton, cancelButton, response, visible, customClass } = props;

  return (
    <Modal
      centered
      open={visible}
      className={customClass}
      title={
        <div className="base-modal__header">
          <BaseIcon className="base-modal__header-icon" white icon={icon} />
          <BaseButtonLink
            className="base-modal__header-close-icon"
            iconLeft
            iconWhite
            icon="times"
            onClick={() => response(MODAL_RESPONSE_TYPE.CLOSE)}
            data-testid="modal-close-icon"
          />
          <h2 className="heading heading--subsection heading--color-white">{title}</h2>
        </div>
      }
      // hide default close icon
      closable={false}
      footer={
        <div className="base-modal__footer">
          <BaseButtonFill data-testid="modal-accept-button" onClick={() => response(MODAL_RESPONSE_TYPE.ACCEPT)}>
            {okButton}
          </BaseButtonFill>
          {cancelButton && (
            <BaseButtonLink
              iconLeft
              icon="arrow-right"
              data-testid="modal-reject-button"
              onClick={() => response(MODAL_RESPONSE_TYPE.REJECT)}
            >
              {cancelButton}
            </BaseButtonLink>
          )}
        </div>
      }
    >
      <div className="base-modal__content">
        {customContent ? description : <p className="copy copy--color-dark">{description}</p>}
      </div>
    </Modal>
  );
};

export default BaseModal;
